import styled from 'styled-components';

export const NestedFilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`;

export const TagsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  max-height: 72px;
  overflow-y: auto;
`;

export const SearchRow = styled.div`
  width: 100%;

  .ant-input-affix-wrapper {
    background: ${({ theme }) => theme.inputBackgroundColor};
    border-color: ${({ theme }) => theme.borderColor};
  }

  .ant-input {
    background: transparent;
    color: ${({ theme }) => theme.textColor};
  }

  .ant-input-suffix {
    color: ${({ theme }) => theme.secondaryTextColor};
    opacity: 0.45;
  }

  .ant-input-suffix .anticon {
    color: inherit;
    font-size: 12px;
  }
`;

export const MakesList = styled.div`
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;
  color: ${({ theme }) => theme.headerColor};
  max-height: 200px;
  overflow-x: hidden;
  overflow-y: scroll;
  overscroll-behavior: contain;
`;

export const MakeRow = styled.div<{ $checked?: boolean }>`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  color: ${({ $checked, theme }) => ($checked ? theme.teal : theme.headerColor)};
  cursor: pointer;
  display: flex;
  gap: 0.5rem;
  padding: 0.4rem 0.6rem;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.selectedListItemBackground};
  }
`;

export const MakeName = styled.span`
  color: inherit !important;
  flex: 1 1 auto;
  font-weight: 600;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ModelCountBadge = styled.span`
  background: ${({ theme }) => theme.tertiaryBackgroundColor};
  border-radius: 999px;
  color: ${({ theme }) => theme.secondaryTextColor} !important;
  flex-shrink: 0;
  font-size: 0.75rem;
  line-height: 1.2;
  padding: 0.15rem 0.5rem;
`;

export const ExpandButton = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.secondaryTextColor};
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  padding: 0.15rem;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
`;

export const ModelsList = styled.div`
  background: ${({ theme }) => theme.secondaryBackgroundColor};
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
`;

export const ModelRow = styled.div<{ $checked?: boolean }>`
  align-items: center;
  color: ${({ $checked, theme }) => ($checked ? theme.teal : theme.headerColor)};
  cursor: pointer;
  display: flex;
  gap: 0.5rem;
  padding: 0.35rem 0.6rem 0.35rem 2rem;

  > span {
    color: inherit !important;
  }

  &:hover {
    background-color: ${({ theme }) => theme.selectedListItemBackground};
  }
`;

export const EmptyState = styled.div`
  color: ${({ theme }) => theme.secondaryTextColor};
  font-style: italic;
  padding: 0.75rem;
  text-align: center;
`;

export const LoadingState = styled.div`
  color: ${({ theme }) => theme.secondaryTextColor};
  padding: 0.75rem;
  text-align: center;
`;
